import React from "react";
import ApprovalsSection from "../components/Approvals/ApprovalsSection";
import PageHeader from "../components/Common/PageHeader";
import PersonaHeaderInfo from "../components/Common/PersonaHeaderInfo";

// The queue: what is waiting on me, what I have signed, what I submitted. The bell says there is
// work; this is where the work is.
//
// THE BLUE BAR IS THE SHARED ONE, not a local copy. Every other section in Foundation carries it,
// and this page was the exception -- which read as a page that had lost its header rather than one
// that never had it.
export default function ApprovalsPage() {
    return (
        <div style={{display: "flex", flexDirection: "column", flexGrow: 1, height: "100%"}}>
            {/* THE PERSONA BELONGS ON A "MY" PAGE MOST OF ALL: what is waiting on you depends
                    entirely on which persona you are, so a header that does not say which one
                    leaves the whole page unexplained. Every list page carries it; these two
                    did not. */}
            <PageHeader title="My Approvals">
                <PersonaHeaderInfo/>
            </PageHeader>
            <div style={{flex: 1, overflow: "auto"}}>
                <ApprovalsSection/>
            </div>
        </div>
    );
}
